import * as React from "react"
import {array, object, string} from "yup";
import {Grid} from "@mui/material";
import {useAppToast, useValidatorSeeker} from "@ui-seeker/app";
import {DrawerSeeker, SelectSeeker, TagFieldSeeker, TextFieldSeeker} from "@ui-seeker/core";

import {useMonitoringResultsCustomReports} from "./@hooks";
import {monitoringResultsReportFormIsOpen} from "./@signals";

export const OPTIONS_FREQUENCY = [
	{ label: 'Daily', value: 'date' },
	{ label: 'Weekly (Mondays)', value: 'week' },
	{ label: 'Execute Now', value: 'now' }
]


export default function MonitoringResultsReportForm() {
	const { showToast } = useAppToast()
	const {nameReport, frequency, emailsReport, resetFormData, handleSendToBack} = useMonitoringResultsCustomReports()

	const validatorData = useValidatorSeeker({
		nameReport: nameReport.value,
		frequency: frequency.value,
		emailsReport: emailsReport.value,
	}, object({
		nameReport: string().required('Report name must be provided'),
		frequency: string().required('Frequency must be provided'),
		emailsReport: array().min(1, 'At least 1 email is required'),
	}))

	if (!monitoringResultsReportFormIsOpen.value)
		return <></>

	return <DrawerSeeker
		isOpen={monitoringResultsReportFormIsOpen.value}
		controller={() => {
			monitoringResultsReportFormIsOpen.value = false
			resetFormData()
		}}
		title="Create New Monitoring Results Report"
		width="40%"
		successProps={{
			disabled: !validatorData.isValid,
			onClick: handleSendToBack
		}}
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<TextFieldSeeker
					error={validatorData.errors?.nameReport}
					label="Report Name"
					size="small"
					fullWidth
					value={nameReport.value}
					onChange={e => nameReport.value = e.target.value}
					icon="pen-to-square"
				/>
			</Grid>

			<Grid item xs={12}>
				<SelectSeeker
					error={validatorData.errors?.frequency}
					label="Frequency"
					fullWidth
					options={OPTIONS_FREQUENCY}
					value={frequency.value}
					onChange={e => frequency.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<TagFieldSeeker
					error={validatorData.errors?.emailsReport}
					label="Emails"
					fullWidth
					value={emailsReport.value}
					onChange={e => emailsReport.value = e}
					placeholder="Enter to add emails"
				/>
			</Grid>
		</Grid>
	</DrawerSeeker>
}